export default __webpack_public_path__ + "static/media/EricSmile.d1c8b664.jpg";